
import type { PropType } from 'vue'
import type { Route } from 'vue-router'
import type { NavigationMenuItem } from '../../models/components/navigation-menu-item'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../enums'
import { UiMenu, UiPopover, UiRippleInk } from '../keen-ui'
import { EpbText } from '../shared/epb-text'

export interface IItemStyles {
  transition?: string
}

export default defineComponent({
  name: 'NavigationMenuItem',
  components: {
    EpbText,
    UiMenu,
    UiPopover,
    UiRippleInk,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: String,
    route: Object as PropType<Route>,
    contrast: Boolean,
    children: {
      type: Array as PropType<Array<NavigationMenuItem>>,
      default: () => [],
    },
    level: {
      type: Number,
      default: 0,
    },
    isModal: Boolean,
    selected: Boolean,
    collapsed: Boolean,
    isNew: Boolean,
    transition: {
      type: [Boolean, Object] as PropType<
        boolean | { durationInMillis: number; delayInMillis: number }
      >,
      default: true,
    },
  },
  setup() {
    return {
      ColorEnum,
    }
  },
  data() {
    return {
      showChildrenPopover: false,
    }
  },
  computed: {
    componentStyles(): IItemStyles {
      let styles: IItemStyles = {}
      if (typeof this.transition === 'object') {
        const opacityTransitionDurationInMillis = this.transition.durationInMillis / 2
        const opacityTransitionDelayInMillis =
          this.transition.delayInMillis + opacityTransitionDurationInMillis
        styles = {
          transition: `height ${this.transition.durationInMillis}ms ${this.transition.delayInMillis}ms, opacity ${opacityTransitionDurationInMillis}ms ${opacityTransitionDelayInMillis}ms`,
        }
      }
      return styles
    },
    menuOptions(): Array<NavigationMenuItem> {
      return [...this.children]
    },
  },
  watch: {
    collapsed(): void {
      if (this.$refs.childrenPopover) {
        this.$refs.childrenPopover.close()
      }
    },
    showChildrenPopover(): void {
      if (this.showChildrenPopover) {
        this.$refs.childrenPopover.open()
      } else {
        this.$refs.childrenPopover.close()
      }
    },
  },
  methods: {
    onMenuSelect(option): void {
      if (option.id === this.id && this.route) {
        this.$router.push(this.route)
      }
      this.$emit('itemMouseSelect')
    },
    click(): void {
      if (this.route) {
        this.$router.push(this.route)
      }
      this.$emit('itemMouseSelect')
    },
    onHover(hover: boolean): void {
      this.showChildrenPopover = hover
    },
  },
})
